<script setup lang="ts">
	import { twMerge } from 'tailwind-merge'
	const { class: classes, ...attrs } = useAttrs()
</script>

<template>
	<div class="size-10">
		<button :class="twMerge('w-full h-full flex flex-col gap-y-2.5 group cursor-pointer', classes)" aria-label="Navigation öffnen" title="Navigation öffnen">
			<span class="block w-full border-t-[3px] border-black group-hover:translate-y-3.25 transition-all duration-150 ease-in-out"></span>
			<span class="block w-full border-t-[3px] border-black"></span>
			<span class="block w-full border-t-[3px] border-black group-hover:-translate-y-3.25 transition-all duration-150 ease-in-out"></span>
		</button>
	</div>
</template>
